export default __webpack_public_path__ + "static/crypto-kitties-533781f4347773c550def99bc377364d.png";